<template>
    <div>
        <table class="table is-fullwidth">
            <thead>
                <tr height="40px">
                    <th><base-skeleton width="17px"/></th>
                    <th><base-skeleton width="60px"/></th>
                    <th><base-skeleton width="90px"/></th>
                    <th><base-skeleton width="90px"/></th>
                    <th><base-skeleton width="90px"/></th>
                </tr>
            </thead>

            <tbody>
                <tr v-for="i in items" :key="i" height="42px">
                    <th><base-skeleton width="17px"/></th>
                    <td><base-skeleton :width="randint(45, 150) + 'px'"/></td>
                    <td><base-skeleton :width="randint(25, 45) + 'px'"/></td>
                    <td><base-skeleton width="90px"/></td>
                    <td><base-skeleton width="120px" height="23px"/></td>
                </tr>
            </tbody>
        </table>

        <paginator-skeleton/>
    </div>
</template>

<script>
import randint from '../../utils/random';
import PaginatorSkeleton from './PaginatorSkeleton.vue';

export default {
    name: 'TeamsSkeleton',
    components: { PaginatorSkeleton },
    props: { items: { type: Number, default: 7 } },
    methods: { randint },
};
</script>

<style scoped>
</style>
